import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getPlatformCards } from '../../utils/profileUtils';
import { experience, education } from '../../data/content';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const platformCards = getPlatformCards();

  const skills = [
    { name: 'System Design', level: 88 },
    { name: 'AI/ML/RL', level: 95 },
    // { name: 'LLMs/MCP/Agentic AI', level: 95 },
    { name: 'Java/Spring Boot', level: 95 },
    { name: 'React/Angular/JavaScript', level: 92 },
    { name: 'Python/Scripting Languages', level: 90 },
    { name: 'Secure Coding/Security by Design ', level: 85 },
    // { name: 'AWS/Cloud', level: 85 },

  ];

  return (
    <aside className="sidebar">
      <div className="profile-section">
        <div className="profile-photo">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Victor Barbarosh" />
        </div>
        <h2>Victor Barbarosh</h2>
        <p className="title">Senior Full-Stack Developer</p>
        <div className="status">
          <span className="status-indicator"></span>
          [busy] Writing Code for Coffee
        </div>
      </div>

      <div className="connect-section">
        <h3>Connect</h3>
        <div className="action-buttons">
          <a href="https://www.linkedin.com/in/victor-barbarosh-56a03743" className="action-btn" target="_blank" rel="noopener noreferrer">
            <svg className="platform-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            LinkedIn
          </a>
          <a href="https://github.com/vBarbaros" className="action-btn" target="_blank" rel="noopener noreferrer">
            <svg className="platform-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
            GitHub
          </a>
        </div>
      </div>

      <div className="education-section">
        <h3>Education</h3>
        {education.map((edu, index) => (
          <div key={index} className="education-item">
            <div className="education-degree">{edu.degree}</div>
            <div className="education-school">{edu.school}</div>
            <div className="education-period">{edu.period}</div>
          </div>
        ))}
      </div>

      <div className="experience-section">
        <h3>Experience</h3>
        {experience.map((job, index) => (
          <div key={index} className="experience-item">
            <div className="experience-title">{job.title}</div>
            <div className="experience-company">{job.company}</div>
            <div className="experience-period">{job.period}</div>
          </div>
        ))}
      </div>

      <div className="skills-section">
        <h3>Skills</h3>
        {skills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-name">{skill.name}</div>
            <div className="skill-bar">
              <div
                className="skill-progress"
                style={{ width: `${skill.level}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      <div className="tech-stack">
        <h3>Tech Stack</h3>
        <div className="tech-tags">
          <span className="tech-tag">Java</span>
          <span className="tech-tag">Spring</span>
          <span className="tech-tag">React</span>
          <span className="tech-tag">Python</span>
          <span className="tech-tag">Docker</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
